import axios from "axios";

// Proxied via setupProxy.js
const BASE_URL = "/api/text";

async function postText(action, data) {
  try {
    const response = await axios.post(`${BASE_URL}?action=${action}`, data, {
      timeout: 30000,
    });
    return response.data || {};
  } catch (err) {
    console.error("Text API error", err);
    throw err;
  }
}

export const summarizeText = (data) => postText("summarize", data);
export const shortFormText = (data) => postText("short-form", data);
export const expandText = (data) => postText("expand", data);
export const classifyPayload = (data) => postText("classify", data);
export const sentimentPayload = (data) => postText("sentiment", data);
export const generateImageFromText = (data) => postText("generate-image", data);
